import React from 'react'

import {
  FieldType,
  ContainsEditableProps,
  useEditor,
  EditableComponentName
} from '@toasttab/sites-components'

import { DividerStyleEnum } from 'src/apollo/sites'

type Props = {
  color?: string | null
  backgroundColor?: string | null
  width?: number | null
  style?: DividerStyleEnum | null
} & ContainsEditableProps

const DividerSection = ({
  color = '#000000',
  backgroundColor,
  width = 1,
  style = DividerStyleEnum.Solid,
  editPath
}: Props) => {
  const { useEditableRef, isEditor } = useEditor()

  const { editableRef } = useEditableRef<HTMLDivElement>({
    name: 'divider section' as EditableComponentName,
    displayName: 'Divider Section',
    actions: ['move-up', 'move-down', 'duplicate', 'delete'],
    path: editPath,
    schema: {
      fields: [
        {
          path: `${editPath}.color`,
          displayName: 'Border Color',
          type: FieldType.Color,
          value: color
        },
        {
          path: `${editPath}.backgroundColor`,
          displayName: 'Background Color',
          type: FieldType.Color,
          value: backgroundColor
        },
        {
          path: `${editPath}.width`,
          displayName: 'Border Width',
          type: FieldType.Number,
          value: width
        },
        {
          path: `${editPath}.style`,
          displayName: 'Border Style',
          type: FieldType.Enum,
          value: style,
          enums: [
            { displayName: 'Solid', value: DividerStyleEnum.Solid },
            { displayName: 'Dashed', value: DividerStyleEnum.Dashed },
            { displayName: 'Dotted', value: DividerStyleEnum.Dotted },
            { displayName: 'Double', value: DividerStyleEnum.Double }
          ]
        }
      ]
    }
  })

  if (isEditor && editPath) {
    return (
      <div
        style={{
          width: '100%',
          backgroundColor: backgroundColor || 'transparent',
          position: 'relative'
        }}
      >
        <div
          id={editPath}
          ref={editableRef}
          data-overlay-top='48'
          style={{
            position: 'absolute',
            width: '100%',
            top: '-48px',
            bottom: '-48px',
            cursor: 'pointer'
          }}
        />
        <hr
          style={{
            width: '100%',
            height: '0',
            margin: 0,
            border: 'none',
            borderTop: `${width}px ${style} ${color}`
          }}
        />
      </div>
    )
  }

  return (
    <hr
      style={{
        width: '100%',
        height: '0',
        margin: 0,
        border: 'none',
        borderTop: `${width}px ${style} ${color}`,
        backgroundColor: backgroundColor || 'transparent'
      }}
    />
  )
}

export default DividerSection
